import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactSelection extends EventRegistryCategory {
    label = 'Selection Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    select = () => new EventRegistryItem({ handlerName: 'onSelect' });
}
